import * as React from 'react';
import type { SVGProps } from 'react';
const SvgToolAppInfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <rect width={48} height={48} fill="#787887" rx={24} />
    <path
      fill="#fff"
      d="M24 12.375c6.375 0 11.625 5.25 11.625 11.625 0 6.422-5.25 11.625-11.625 11.625-6.422 0-11.625-5.203-11.625-11.625 0-6.375 5.203-11.625 11.625-11.625m0 21c5.156 0 9.375-4.172 9.375-9.375 0-5.156-4.219-9.375-9.375-9.375-5.203 0-9.375 4.219-9.375 9.375A9.343 9.343 0 0 0 24 33.375m5.016-11.953c0 3.14-3.422 3.187-3.422 4.36v.28a.54.54 0 0 1-.563.563h-2.11a.54.54 0 0 1-.562-.562v-.375c0-1.688 1.266-2.344 2.203-2.907.844-.468 1.36-.75 1.36-1.36 0-.843-1.031-1.358-1.875-1.358-1.078 0-1.594.515-2.297 1.406a.585.585 0 0 1-.797.093l-1.312-.984a.53.53 0 0 1-.094-.75c1.078-1.64 2.484-2.578 4.687-2.578 2.297 0 4.782 1.828 4.782 4.172m-3.047 7.828A1.95 1.95 0 0 1 24 31.219c-1.125 0-1.969-.844-1.969-1.969A1.95 1.95 0 0 1 24 27.281a1.98 1.98 0 0 1 1.969 1.969"
    />
  </svg>
);
export default SvgToolAppInfoIcon;
